import request from '@/utils/request'

/**
 * 退车解约前置校验，校验是否延期代扣 https://mock-test.cheweijia.com/project/10282/interface/api/492179
 * @param {*} orderId 订单ID
 * @returns
 */
export function preTerminate(orderId) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/return/lease/extendValid',
    method: 'post',
    data: {
      orderId,
    },
  })
}

// 订单确认租赁合同获取签署详情 https://mock-test.cheweijia.com/project/10282/interface/api/492749
export function orderConfirmQueryContract(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/rent/queryContract',
    method: 'post',
    data,
  })
}

// 租赁合同线上签约发起(单独租赁合同使用)
export function startSignContract(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/rent/startSign',
    method: 'post',
    data,
    bizCode: [13997],
  })
}

// 租赁合同线上签署撤销(单独租赁合同使用)
export function cancelSignContract(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/rent/cancel',
    method: 'post',
    data,
  })
}

// 租赁合同预览
export function previewOrderContract(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/rent/preview',
    method: 'post',
    data,
  })
}

// 代扣合同预览
export function previewContract(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/wallet/preview',
    method: 'post',
    data,
  })
}

// 查询网约钱包支付合同详情
export function queryContractWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/wallet/queryContract',
    method: 'post',
    data,
  })
}

// 脱敏查询网约钱包支付合同详情
export function queryContractWithholdSensitive(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/wallet/queryContract/sensitive',
    method: 'post',
    data,
  })
}

// 撤销网约钱包支付
export function cancelWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/wallet/cancel',
    method: 'post',
    data,
  })
}

// 查询网约钱包签署详情（新接口）
export function getWalletSignDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/signFlow/wallet/signDetail',
    method: 'post',
    data,
  })
}

// 网约钱包支付合同发起(网约钱包支付专用)
export function startSignWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/wallet/startSign',
    method: 'post',
    data,
    bizCode: [13997],
  })
}

// 解约网约钱包支付
export function cancelWalletWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/wallet/break',
    method: 'post',
    data,
  })
}

// 解约支付宝支付
export function cancelAlipayWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/withhold/break',
    method: 'post',
    data,
  })
}

// 检查是否支持网约钱包支付
export function checkWalletWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/rent/order/walletWithhold/check',
    method: 'POST',
    data,
    bizCode: [29030],
  })
}

export function getPersonWithholdCustomerInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/getPersonWithholdCustomerInfo',
    method: 'post',
    data,
  })
}

